  import React, { useState, useEffect } from 'react';
  import { Link, useLocation } from 'react-router-dom';
  import logo from '../../assets/rhythmoflife-logo.png';

  const PublicNavbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const location = useLocation();

    // Navigation links
    const navLinks = [
      { path: '/', label: 'Home' },
      { path: '/about', label: 'About' },
      { path: '/services', label: 'Services' },
      { path: '/self-help', label: 'Self-Help Tools' },
      { path: '/mental-health-guide', label: 'Resources' },
      // { path: '/booking/find-provider', label: 'Find Provider' },
      { path: '/contact', label: 'Contact' },
    ];

    const isActive = (path) => location.pathname === path;

    // Handle window resize for responsive behavior
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
        // Auto close mobile menu on desktop
        if (window.innerWidth >= 1024) {
          setMobileMenuOpen(false);
        }
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Add scroll effect
    useEffect(() => {
      const handleScroll = () => {
        setScrolled(window.scrollY > 20);
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu when clicking outside
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      mobileMenuOpen &&
      !event.target.closest('.mobile-menu-container') &&
      !event.target.closest('.menu-toggle-btn')
    ) {
      setMobileMenuOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [mobileMenuOpen]);


    // Close menu when route changes
    useEffect(() => {
      setMobileMenuOpen(false);
    }, [location]);

    // Prevent body scroll when mobile menu is open
    useEffect(() => {
      if (mobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
      return () => {
        document.body.style.overflow = 'unset';
      };
    }, [mobileMenuOpen]);

    return (
      <>
        {/* Main Navbar - Responsive across all devices */}
        <nav
          className={`
            fixed top-0 left-0 right-0 z-50
            bg-white/95 backdrop-blur-md
            transition-all duration-300 ease-in-out
            ${scrolled
              ? 'shadow-lg border-b border-gray-100 py-3 md:py-3'
              : 'shadow-md border-b border-gray-200 py-3.5 md:py-3.5'
            }
          `}
        >
          <div className="container mx-auto px-2 sm:px-3 lg:px-4">
            <div className="flex items-center justify-between">
              {/* Logo Section - Responsive sizing */}
              <Link
                to="/"
                className="flex items-center space-x-2 sm:space-x-3 group"
              >
                {/* <div className={`
                  bg-gradient-to-br from-serene-blue-500 to-growth-green-500 
                  rounded-lg sm:rounded-xl p-1.5 sm:p-2
                  transition-all duration-300 group-hover:scale-110
                  ${scrolled ? 'w-8 h-8 sm:w-9 sm:h-9' : 'w-9 h-9 sm:w-10 sm:h-10'}
                `}> */}
                  <img src={logo} alt="Rhythm of life" style={{ height: scrolled ? '60px' : '85px', width: 'auto' }} />
                  {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full text-white lucide lucide-brain-icon lucide-brain"><path d="M12 18V5"/><path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4"/><path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"/><path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"/><path d="M18 18a4 4 0 0 0 2-7.464"/><path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"/><path d="M6 18a4 4 0 0 1-2-7.464"/><path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"/></svg> */}
                {/* </div> */}
                {/* <div>
                  <h1 className={`
                    font-bold bg-gradient-to-r from-serene-blue-600 to-growth-green-600 
                    bg-clip-text text-transparent transition-all duration-300
                    ${scrolled ? 'text-lg sm:text-xl' : 'text-xl sm:text-2xl'}
                  `}>
                    Rhythm of life
                  </h1>
                  <p className="text-[10px] sm:text-xs text-gray-500 font-medium -mt-0.5 hidden sm:block">
                    Mental Health & Wellness
                  </p>
                </div> */}
              </Link>

              {/* Desktop Navigation - Hidden on mobile and tablet */}
              <div className="hidden lg:flex items-center space-x-1 xl:space-x-2">
                {navLinks.map((link, index) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onMouseEnter={() => setHoveredItem(index)}
                    onMouseLeave={() => setHoveredItem(null)}
                    className={`
      relative
      px-2 md:px-3 lg:px-2 xl:px-4   /* reduce horizontal padding on medium screens */
      py-1 md:py-2 lg:py-2 xl:py-2 /* reduce vertical padding */
      font-small text-xs md:text-xs lg:text-xs xl:text-sm  /* smaller font for iPad Pro */
      rounded-lg transition-all duration-300
      ${isActive(link.path)
                        ? 'text-serene-blue-600'
                        : 'text-gray-700 hover:text-serene-blue-600'
                      }
    `}
                  >
                    {/* Background hover effect */}
                    <div className={`
      absolute inset-0 rounded-lg
      bg-gradient-to-r from-serene-blue-50 to-growth-green-50
      transition-all duration-300
      ${isActive(link.path) || hoveredItem === index ? 'opacity-100' : 'opacity-0'}
    `}></div>

                    {/* Text */}
                    <span className="relative whitespace-nowrap">{link.label}</span> {/* prevents line break */}

                    {/* Active Indicator Line */}
                    <div className={`
      absolute bottom-1 left-1/2 transform -translate-x-1/2
      h-0.5 bg-gradient-to-r from-serene-blue-500 to-growth-green-500
      transition-all duration-300 ease-out
      ${isActive(link.path)
                        ? 'w-full opacity-100'
                        : hoveredItem === index
                          ? 'w-3/4 opacity-60'
                          : 'w-0 opacity-0'}
    `}></div>
                  </Link>

                ))}
              </div>

              {/* Right Side Actions */}
              <div className="flex items-center space-x-2 sm:space-x-3">
                {/* Auth Buttons - Only visible on desktop */}
                <div className="hidden lg:flex items-center space-x-2 xl:space-x-3">
                  <a
                    href="https://app.rhythmoflife.coach"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
                      relative px-4 xl:px-5 py-2 xl:py-2 
                      text-xs xl:text-sm
                      text-serene-blue-600 font-semibold
                      border-2 border-serene-blue-200
                      rounded-full
                      overflow-hidden
                      transition-all duration-300
                      hover:border-serene-blue-400
                      hover:shadow-lg
                      group
                    "
                  >
                    <span className="relative z-10">Login</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-serene-blue-50 to-white transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300"></div>
                  </a>

                  <a
                    href="https://app.rhythmoflife.coach/auth/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
                      relative px-4 xl:px-5 py-2 xl:py-2
                      text-xs xl:text-sm
                      bg-gradient-to-r from-serene-blue-500 to-growth-green-500
                      text-white font-semibold
                      rounded-full
                      overflow-hidden
                      transform transition-all duration-300
                      hover:scale-105 hover:shadow-xl
                      whitespace-nowrap
                      group
                    "
                  >
                    <span className="relative z-10">Get Started</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-serene-blue-600 to-growth-green-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </a>
                </div>

                {/* Mobile/Tablet Menu Button - Visible up to desktop */}
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  
                  className="
                    menu-toggle-btn
                    lg:hidden 
                    text-gray-700 p-2 rounded-lg 
                    hover:bg-gray-100 
                    transition-all duration-200
                    focus:outline-none focus:ring-2 focus:ring-serene-blue-500
                  "
                  aria-label="Toggle navigation menu"
                >
                  <div className="w-6 h-6 relative">
                    <span className={`absolute left-0 h-0.5 w-full bg-gray-700 rounded transition-all duration-300
                    ${mobileMenuOpen ? 'top-2.5 rotate-45' : 'top-0'}`}></span>
                    <span className={`absolute left-0 top-2.5 h-0.5 w-full bg-gray-700 rounded transition-all duration-300
                    ${mobileMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                    <span className={`absolute left-0 h-0.5 w-full bg-gray-700 rounded transition-all duration-300
                    ${mobileMenuOpen ? 'top-2.5 -rotate-45' : 'top-5'}`}></span>
                  </div>
                </button>
              </div>
            </div>

            {/* Mobile & Tablet Menu - Slide down animation for screens below 1024px */}
            <div
              className={`
                mobile-menu-container
                lg:hidden overflow-hidden
                transition-all duration-500 ease-in-out
                ${mobileMenuOpen
                  ? 'max-h-[calc(100vh-4rem)] opacity-100 mt-4'
                  : 'max-h-0 opacity-0'
                }
              `}
            >
              <div className="py-4 border-t border-gray-200">
                {/* Mobile Navigation Links */}
                <div className="space-y-1 px-2">
                  {navLinks.map((link, index) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => setMobileMenuOpen(false)}
                      className={`
                        block relative
                        py-3 px-4 rounded-lg
                        font-semibold text-base
                        transform transition-all duration-300
                        ${isActive(link.path)
                          ? 'text-serene-blue-600 bg-serene-blue-50/50 translate-x-2'
                          : 'text-gray-700 hover:bg-gray-50 hover:translate-x-2'
                        }
                      `}
                      style={{
                        transitionDelay: `${index * 50}ms`,
                        animation: mobileMenuOpen
                          ? `slideInLeft ${300 + (index * 100)}ms ease-out`
                          : 'none'
                      }}
                    >
                      <span>{link.label}</span>
                      {/* Active indicator bar */}
                      {isActive(link.path) && (
                        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-1 h-8 bg-gradient-to-b from-serene-blue-500 to-growth-green-500 rounded-r-full"></div>
                      )}
                    </Link>
                  ))}
                </div>

                {/* Mobile Auth Buttons */}
                <div className="mt-6 px-4 space-y-3">
                  <a
                    href="https://parivartan-app.abacies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setMobileMenuOpen(false)}
                    className="
                      block text-center
                      w-full py-3 
                      border-2 border-serene-blue-500
                      text-serene-blue-600 font-semibold
                      rounded-full
                      transition-all duration-300
                      hover:bg-serene-blue-50
                      active:scale-95
                    "
                  >
                    Login
                  </a>
                  <a
                    href="https://parivartan-app.abacies.com/auth/register"
                    onClick={() => setMobileMenuOpen(false)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
                      block text-center
                      w-full py-3
                      bg-gradient-to-r from-serene-blue-500 to-growth-green-500
                      text-white font-semibold
                      rounded-full
                      transition-all duration-300
                      hover:shadow-lg
                      transform hover:scale-105
                      active:scale-95
                    "
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {/* Spacer to prevent content from going under fixed navbar */}
        <div className={`${scrolled ? 'h-14 sm:h-16' : 'h-16 sm:h-20'} transition-all duration-300`}></div>

        {/* Mobile & Tablet menu overlay backdrop */}
        {mobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black/20 z-40 lg:hidden"
            onClick={() => setMobileMenuOpen(false)}
          />
        )}

        {/* Add custom keyframe animations */}
        <style jsx>{`
          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-20px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}</style>
      </>
    );
  };

  export default PublicNavbar;